module.exports = __webpack_public_path__ + "img/example1.813e8b2f.png";